import { createAction } from '@reduxjs/toolkit'
import { ELittleBotTabs, EManualActions, ITradeOptionWithScroll, SearchTabState, TradeOption } from './types'

export const setToken = createAction<{ code: string; name: string }>('setToken')
export const setWithdrawDataFromBalances = createAction<{ fromEx: string; symbol: string; toEx: string }>('setWithdrawDataFromBalances')

export const openConfirmDeleting = createAction<{
  state: boolean
  tradeOption: Pick<TradeOption, 'firstEx' | 'secondEx' | 'market' | 'secondMarket' | '_id'>
}>('openConfirmDeleting')
export const getInfoWindow = createAction<{ type: string; message: string; autoClose?: boolean }>('getInfoWindow')
export const setSelectedTradeOption = createAction<ITradeOptionWithScroll>('setSelectedTradeOption')
export const clearPlaceOrderError = createAction('clearPlaceOrderError')
export const clearWithdrawError = createAction('clearWithdrawError')
export const togglePauseTradeOptionsHistory = createAction<boolean>('togglePauseTradeOptionsHistory')
export const setDexFeMarketExistsManually = createAction<{ exists: boolean }>('setDexFeMarketExistsManually')
export const setDirectExchange = createAction<{ exchange: string; market: string }>('setDirectExchange')
export const clearInfoMsg = createAction<{ type: string; message: string; autoClose?: boolean }>('clearInfoMsg')
export const toggleDraftOpened = createAction<boolean>('toggleDraftOpened')
export const clearDraft = createAction('clearDraft')
export const chooseBotSubTab = createAction<{ tab: ELittleBotTabs }>('chooseBotSubTab')
export const setManualActionsTab = createAction<{ tab: EManualActions }>('setManualActionsTab')
export const setPlaceOrderManualValues = createAction<{
  manualPrice?: { exchange: string; market: string; price: string; accountName: string }
  manualVolume?: { exchange: string; market: string; volume: string; accountName: string }
  manualTotal?: { exchange: string; market: string; total: string; accountName: string }
  withManualTab?: boolean
}>('setPlaceOrderManualValues')

export const editActionsFilterByExchange = createAction<{ firstEx?: string; secondEx?: string; market?: string; secondMarket?: string }>(
  'editActionsFilterByExchange'
)
export const toggleTradeFirstExType = createAction<{ type: string }>('toggleTradeFirstExType')
export const toggleTradeSecondExType = createAction<{ type: string }>('toggleTradeSecondExType')
export const toggleFormManuOpened = createAction<boolean>('toggleFormManuOpened')

export const toFiltersByExchange = createAction<{ exchange?: string }>('toFiltersByExchange')
export const toFiltersByMarket = createAction<{ market?: string }>('toFiltersByMarket')
export const toFiltersBySymbol = createAction<{ symbol?: string }>('toFiltersBySymbol')
export const toFiltersByStatus = createAction<{ status?: string }>('toFiltersByStatus')
export const setSearchTabState = createAction<SearchTabState>('setSearchTabState')
export const setOpenedTradeOption = createAction<boolean>('openedTradeOption')
export const setSearchSortState = createAction<string[]>('searchSortState')
export const isActionOpen = createAction<boolean>('isActionOpen')
export const setRecordsTabOpened = createAction<boolean>('setRecordsTabOpened')
export const setSelectedTimelineDot = createAction<number>('setSelectedTimelineDot')
export const setIsHideRecorderTOList = createAction<boolean>('setIsHideRecorderTOList')
